// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3EltQ","iconStyle":"Header_iconStyle__3eU8T","dynamicHeaderRight":"Header_dynamicHeaderRight__1yOnx","rightWrapper":"Header_rightWrapper__3-Lse"};